import { createSlice, current } from '@reduxjs/toolkit';




const initialState = {
  payment:[]
};

export const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    setPayment: (state, { payload }) => {
     
      state.payment = [...payload];
    },
    
   
    clearPaymentState: (state) => {
      state=initialState
    }
  }
});

export const { setPayment, clearPaymentState } = paymentSlice.actions;

export const paymentData = (state) => state.payment;


export default paymentSlice.reducer;
